import React, { useState, useEffect } from 'react';
import { FileCheck, Sparkles, MapPin, HardHat, Plus, CheckCircle2 } from 'lucide-react';
import { AosrGeneratorModal } from './AosrGeneratorModal';

export const CompletedWorksFeed: React.FC = () => {
  const [feed, setFeed] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedItemForAosr, setSelectedItemForAosr] = useState<any | null>(null);

  const fetchFeed = () => {
    setLoading(true);
    fetch('/api/v1/pto/feed')
      .then(r => r.json())
      .then(d => {
        if (d.success) setFeed(d.data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchFeed();
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-white p-4 rounded-2xl border border-slate-200/90 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)]">
        <div>
          <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">
            <span className="p-2 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-xl">
              <FileCheck className="w-5 h-5" />
            </span>
            <span>Лента выполненных работ от прорабов (под сдачу в АОСР)</span>
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            Оперативные объемы из суточных рапортов, готовые к юридическому освидетельствованию
          </p>
        </div>

        <button
          onClick={() => setSelectedItemForAosr({})}
          className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-xl text-xs font-bold shadow-md shadow-emerald-600/20 transition self-start sm:self-auto active:scale-95"
        >
          <Plus className="w-4 h-4" />
          <span>Сформировать АОСР вручную</span>
        </button>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-sm">Загрузка ленты работ...</div>
      ) : feed.length === 0 ? (
        <div className="p-8 text-center bg-white rounded-2xl border border-slate-200 text-slate-500 text-sm">
          Нет новых рапортов для оформления АОСР.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {feed.map((item) => {
            const hasAosr = (item.aosr_included_count || 0) > 0;
            return (
              <div
                key={item.report_work_item_id}
                className={`p-4 rounded-2xl border transition space-y-3 ${
                  hasAosr
                    ? 'bg-slate-50 border-slate-200/80'
                    : 'bg-white border-emerald-200 hover:border-emerald-300 shadow-sm'
                }`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="space-y-1">
                    <span className="text-[10px] font-bold uppercase tracking-wider text-blue-700 bg-blue-50 px-2 py-0.5 rounded-md border border-blue-200">
                      {item.work_type_code}
                    </span>
                    <h3 className="text-sm font-bold text-slate-900">{item.work_type_name}</h3>
                  </div>

                  <div className="text-right">
                    <span className="text-base font-black text-amber-700">{item.volume_completed} {item.unit}</span>
                    <span className="text-[10px] text-slate-400 block">{item.report_date}</span>
                  </div>
                </div>

                <div className="text-xs text-slate-600 flex flex-wrap items-center gap-x-3 gap-y-1 pt-1 border-t border-slate-100">
                  <span className="flex items-center gap-1 text-slate-700 font-medium">
                    <MapPin className="w-3.5 h-3.5 text-amber-600" />
                    {item.block_name} • {item.floor_name} • {item.zone_name}
                  </span>
                  <span className="flex items-center gap-1 text-slate-500">
                    <HardHat className="w-3.5 h-3.5 text-slate-400" />
                    {item.foreman_name}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-2">
                  {hasAosr ? (
                    <span className="text-xs text-emerald-700 font-bold flex items-center gap-1">
                      <CheckCircle2 className="w-3.5 h-3.5" /> Включено в АОСР
                    </span>
                  ) : (
                    <span className="text-xs text-amber-700 font-semibold">Требуется составление АОСР</span>
                  )}

                  <button
                    onClick={() => setSelectedItemForAosr(item)}
                    className="text-xs bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border border-emerald-200 px-3 py-1.5 rounded-xl font-bold transition active:scale-95"
                  >
                    Сформировать АОСР
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {selectedItemForAosr && (
        <AosrGeneratorModal
          item={selectedItemForAosr}
          onClose={() => setSelectedItemForAosr(null)}
          onSuccess={() => {
            setSelectedItemForAosr(null);
            fetchFeed();
          }}
        />
      )}
    </div>
  );
};
